import { Injectable } from '@angular/core';

import { Action } from '../shared/common.action';

@Injectable()
export class FormAction {

  static key = 'Form';

  static LOAD = `[${FormAction.key}] Load`;
  static LOAD_SUCCESS = `[${FormAction.key}] Load success`;
  static LOAD_FAIL = `[${FormAction.key}] Load fail`;

  static LOAD_ALL = `[${FormAction.key}] Load all`;
  static LOAD_ALL_SUCCESS = `[${FormAction.key}] Load all success`;
  static LOAD_ALL_FAIL = `[${FormAction.key}] Load all fail`;

  public load(id: string): Action {
    return {
      type: FormAction.LOAD,
      payload: {
        id: id
      }
    };
  }

  public loadSuccess(data: any[]) {
    return {
      type: FormAction.LOAD_SUCCESS,
      payload: {
        response: data
      }
    };
  }

  public loadFail(error: any) {
    return {
      type: FormAction.LOAD_FAIL,
      payload: {
        request: undefined,
        response: error
      }
    };
  }

  public loadAll(): Action {
    return {
      type: FormAction.LOAD_ALL,
    };
  }

  public loadAllSuccess(data: any[]) {
    return {
      type: FormAction.LOAD_ALL_SUCCESS,
      payload: {
        response: data
      }
    };
  }

  public loadAllFail(error: any) {
    return {
      type: FormAction.LOAD_ALL_FAIL,
      payload: {
        request: undefined,
        response: error
      }
    };
  }
}
